import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import * as Api from 'utils/Api';
import configuration from 'configuration';
import { useLocalStorage } from 'shared/hooks/useLocalStorage';

const useAutoVersionCheck = (enabled) => {
  const hasReloaded = useRef(false);
  const location = useLocation();
  const [lastChecked, setLastChecked] = useLocalStorage('lastVersionCheck', null);

  const checkVersion = async () => {
    if (!enabled) return;

    try {
      const serverSettings = await Api.fetchPartnerConnectServerSettings();
      const clientVersion = configuration?.version;
      const serverVersion = serverSettings?.version;

      if (!clientVersion || !serverVersion) return;

      const url = new URL(window.location.href);
      if (url.searchParams.get('v') === serverVersion) return;

      if (clientVersion !== serverVersion && !hasReloaded.current) {
        hasReloaded.current = true;
        url.searchParams.set('v', serverVersion);
        history.replaceState(null, '', url);
        window.location.href = url.toString();
      }

      setLastChecked(Date.now());
    } catch (err) {
      console.error('Version check failed:', err);
    }
  };

  useEffect(() => {
    if (!enabled) return;

    const now = Date.now();
    const checkIntervalMs = (configuration?.currentVersionCheckTimeInMinutes ?? 60) * 60 * 1000;

    const fullPath = `${location.pathname}${location.search}`;
    const isCheckableRoute = (
      fullPath === '/' ||
      fullPath === '/attentionNeeded?type=agedPOs' ||
      fullPath === '/AccidentManagement/AccidentAssignments' ||
      fullPath === '/yourAccount' ||
      fullPath === '/carWash'
    );

    const shouldCheck = isCheckableRoute && (!lastChecked || now - lastChecked > checkIntervalMs);

    if (shouldCheck) {
      checkVersion();
    }
  }, [location.pathname, location.search, enabled]);
};

export default useAutoVersionCheck;
